<script setup>
  defineProps({
    title: {
      type: String,
      default: '',
    },
    placeholders: {
      type: [Array, Object],
      default: () => [],
    },
  });

  const copyVariableToClipboard = (variable, key) => {
    navigator.clipboard.writeText(`[[${key}]]`);
    const element = document.getElementById(key);
    element.innerHTML = 'Copied to your clipboard!';

    setTimeout(() => {
      element.innerHTML = variable;
    }, 700);
  };
</script>

<template>
  <div class="placeholders">
    <div class="title">
      {{ title }}
    </div>
    <div class="tags_wrapper xs-mb-20">
      <div
        v-for="(variable, key) in placeholders"
        :id="key"
        :key="key"
        class="tag_item label label-info xs-mr-10"
        @click="copyVariableToClipboard(variable, key)"
      >
        {{ variable }}
      </div>
    </div>
  </div>
</template>

<style scoped>
  .tag_item:not(:last-of-type) {
    margin-bottom: 0.5rem;
  }

  .tag_item {
    border-radius: .75rem;
    background-color: #E8E5E2;
    padding: 10px;
    font-size: .8rem;
    line-height: 1;
    transition: .3s;
    user-select: none;
    cursor: pointer;
    color:#040707;
  }

  .tag_item:hover {
    color: #fff;
    background-color: #37B2A8;
  }

  .tags_wrapper {
    display: flex;
    flex-direction: column;
    color: #040707;
  }

  .title {
    text-align: center;
    font-size: .75rem;
    line-height: 1.25;
    letter-spacing: 3px;
    text-transform: uppercase;
    margin-bottom: 1.5em;
  }

  .placeholders > .title {
    text-align: center;
    font-size: .75rem;
    line-height: 1.25;
    letter-spacing: 3px;
    text-transform: uppercase;
    margin-bottom: 1.5em;
    color: #040707;
  }
</style>
